import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";

import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import { FieldArray, Form, Formik } from "formik";
import { Accordion } from "react-bootstrap";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { FormikDropdown } from "../../components/dropdown";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { coursesRef, getCoursesListQuery, initialValues, handleSubmit } = useBlogsProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="SubHeading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 mt-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.description" rootClassName="w-full" as="textarea" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Courses List</Accordion.Header>
                <Accordion.Body>
                  <div className="flex justify-end mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={() => coursesRef?.current?.push({ course: "" })}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="courses.selectedCourses">
                    {(arrayHelpers) => {
                      coursesRef.current = arrayHelpers;

                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300 mb-4">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Courses</th>
                                <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Keywords (' , ' separated)</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.courses?.selectedCourses?.map((item, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikDropdown
                                      options={
                                        getCoursesListQuery?.data?.data?.data?.map((course) => ({
                                          label: course.title,
                                          value: course.id,
                                        })) || []
                                      }
                                      name={`courses.selectedCourses.${index}.course`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikInput name={`courses.selectedCourses.${index}.keyword`} rootClassName="w-full" />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => coursesRef?.current?.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
